import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import {
  AUTH,
  ENHANCE_GUEST_QUIZ,
  PAYMENT,
  DEAR_DR_PDF,
  DEAR_SDM_PDF,
  EXPLORE_PDF,
  LOGIN,
  PREP_FQ_PDF,
  ASIP_REMINDER,
  EQUIP_REPRESENT_PDF,
  EQUIP_PERSONAL_DIRECTIVE_PDF,
  EMPOWER_CAREGIVER_REPORTS_PDF,
  ENTRUST_DEAR_LAWYER_PDF,
  EMPOWER_PATIENT_REPORTS_PDF,
  DEAR_ICU_TEAM_PDF,
  DEAR_SUPPORT_TEAM_PDF,
  ENHANCE_PDF,
} from "../constants/routes";
import { routerPushAndScroll } from "../utils/router";
import AuthContext from "./AuthContext";
import useUser from "./useUser";
import useUserMetadata from "./useUserMetadata";
import logger from "../../src/utils/logger";
import { PwgError } from "../models/common";
import { getAuth, onIdTokenChanged, User } from "firebase/auth";
import { firebaseApp } from "./firebaseClient";

const pagesToIgnore = [PREP_FQ_PDF, ENHANCE_PDF, ASIP_REMINDER];
const pathsToIgnore = [
  AUTH,
  PAYMENT,
  ENHANCE_GUEST_QUIZ,
  DEAR_DR_PDF,
  DEAR_SDM_PDF,
  EXPLORE_PDF,
  EQUIP_REPRESENT_PDF,
  EMPOWER_CAREGIVER_REPORTS_PDF,
  EMPOWER_PATIENT_REPORTS_PDF,
  ENTRUST_DEAR_LAWYER_PDF,
  DEAR_ICU_TEAM_PDF,
  DEAR_SUPPORT_TEAM_PDF,
  EQUIP_PERSONAL_DIRECTIVE_PDF,
];
function AuthProvider({ children }: any) {
  const router = useRouter();
  const [authUser, setAuthUser] = useState<User | null>(null);
  const [entryPage, setEntryPage] = useState("");
  const { mutate } = useUser(authUser?.uid);
  const {} = useUserMetadata(authUser?.uid);

  useEffect(() => {
    const auth = getAuth(firebaseApp);
    const unsubscribe = onIdTokenChanged(auth, async (authUser: User) => {
      try {
        if (!authUser) {
          setAuthUser(null);
          mutate();
          if (
            pagesToIgnore.every((page) => router.pathname !== page) &&
            pathsToIgnore.every((page) => !router.pathname.includes(page))
          ) {
            setEntryPage(router.asPath);
            routerPushAndScroll(router, LOGIN);
          }
          return;
        } else {
          setAuthUser(authUser);
          mutate();
          if (!authUser.emailVerified) {
            if (
              pagesToIgnore.every((page) => router.pathname !== page) &&
              pathsToIgnore.every((page) => !router.pathname.includes(page))
            ) {
              routerPushAndScroll(router, LOGIN);
            }
          }
          return;
        }
      } catch (error) {
        const pwgError: PwgError = {
          user_id: authUser.uid,
          ssr: false,
          context: "AuthProvider",
          date_created: new Date().getTime(),
          error: error?.toString(),
          pathname: router.asPath,
        };
        await logger.e(
          "🚀 ~ file: AuthProvider.tsx ~ line 58 ~ error",
          error,
          pwgError
        );
      }
    });
    return () => unsubscribe();
  }, [authUser, mutate, router.pathname, router]);
  return (
    <AuthContext.Provider value={{ user: authUser, entry_page: entryPage }}>
      {children}
    </AuthContext.Provider>
  );
}

export default AuthProvider;
